import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Row, Col, Form, Button } from "react-bootstrap";
import { Add } from "iconsax-react";

import {
  ROUTE_COMPANY_DETAIL,
  ROUTE_AUTHENTICATION,
  ROUTE_PAYMENT,
} from "../../../../routes";

import grouplImg from "../../../../image/purchase/group-subscription.png";
import { educationApi } from "../../../../utility/api/apiList";

import { educationTypes, educationGender } from "../../../../libs/getConstants";

import cartType from "../../../../redux/actions/cart/cartType";
import {
  closeAlert,
  showSuccessAlert,
  showDangerAlert,
  showInfoAlert,
  showModalAlert,
} from "../../../../redux/actions/alert/alertActions";

import useAxios from "../../../../hooks/useAxios";

import EditCompanyDetail from "../../../../containers/purchase/companyDetail/editCompanyDetail";
import LayoutPurchaseComponent from "../layoutPurchase";
import CartTableComponent from "./cartTable";
import CompanyCardsComponent from "./companyCards";
import SecondaryButtonComponent from "../secondaryButton";

import {
  Wrapper,
  StyledCreateNewCompany,
  StyledCompanyCardsWrapper,
  StyledContainer,
} from "../../../../containers/purchase/cart/styledcartPage";

const CartComponent = ({
  educationList,
  getEducationList,
  productList,
  theadData,
}) => {
  //select company
  const [selectedCompany, setSelectedCompany] = useState("");
  const [constantsGenderList, setConstantsGenderList] = useState([]);
  const [constantsTypeList, setConstantsTypeList] = useState([]);
  const [constantsList, setConstantsList] = useState([]);
  const [selectedCompanyDetail, setSelectedCompanyDetail] = useState(null);
  const [companyIdWillRemove, setCompanyIdWillRemove] = useState("");

  const history = useHistory();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.userDetail);
  const constantsDetail = useSelector((state) => state.constantsDetail);

  const educationType = educationTypes();
  const educationGenders = educationGender();

  const schema = yup.object().shape({
    selected_company: yup.string().required(),
  });

  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { run: deleteEducationRun } = useAxios({
    url: `${educationApi}${companyIdWillRemove.id}/`,
    method: "delete",
  });

  useEffect(() => {
    if (constantsDetail.constants.length !== 0) {
      setConstantsList(constantsDetail.constants.other);
      var count = Object.keys(educationType).length;
      var array = [];
      for (var i = 0, emp; i < count; i++) {
        emp = educationType[i];
        array.push({ id: i, name: emp });
      }
      var genderArray = [];
      var countGender = Object.keys(educationGenders).length;
      for (var i = 0, empGender; i < countGender; i++) {
        empGender = educationGenders[i];
        genderArray.push({ id: i, name: empGender });
      }
      setConstantsGenderList(genderArray);
      setConstantsTypeList(array);
    }
  }, [constantsDetail.constants]);

  useEffect(() => {
    if (selectedCompanyDetail) {
      dispatch(
        showModalAlert({
          maxWidth: "690px",
          content: (
            <EditCompanyDetail
              data={selectedCompanyDetail}
              updateEditedDatas={getEducationList}
            />
          ),
          notCentered: true,
        })
      );
    }
  }, [selectedCompanyDetail]);

  useEffect(() => {
    if (companyIdWillRemove) {
      dispatch(
        showModalAlert({
          maxWidth: "340px",
          content: <DeleteModal />,
        })
      );
    }
  }, [companyIdWillRemove]);

  const handleCreateNewCompany = () => {
    if (userDetail.isLogin) {
      return ROUTE_COMPANY_DETAIL;
    } else {
      return {
        pathname: ROUTE_AUTHENTICATION,
        state: { prevPath: ROUTE_COMPANY_DETAIL },
      };
    }
  };

  const handleDeleteModal = (e) => {
    setCompanyIdWillRemove({ id: e.target.id, name: e.target.name });
  };

  const handleDeleteCompany = () => {
    deleteEducationRun()
      .then(() => {
        dispatch(closeAlert());
        dispatch({ type: cartType.SET_COMPANY_DETAILS, payload: [] });
        dispatch(showSuccessAlert("سازمان با موفقیت حذف شد."));
        getEducationList();
      })
      .catch((error) => {
        dispatch(closeAlert());
        dispatch(
          showDangerAlert(
            "این سازمان به دلیل داشتن فاکتور، قابل پاک کردن نیست."
          )
        );
        if (error.response.status === 500) {
          dispatch(
            showDangerAlert(
              "این سازمان به دلیل داشتن فاکتور، قابل پاک کردن نیست."
            )
          );
        } else {
          dispatch(showDangerAlert("مشکلی پیش آمده، دوباره امتحان کنید."));
        }
      });
  };

  const handleEditModal = (e) => {
    const arrayCompany = educationList.results.find(
      (item) => item.id == e.target.id
    );
    const typeLabel = constantsTypeList.find(
      (item) => item.id === arrayCompany.type
    );
    const genderLabel = constantsGenderList.find(
      (item) => item.id === arrayCompany.gender
    );
    setSelectedCompanyDetail({
      ...arrayCompany,
      typeLabel: typeLabel,
      genderLabel: genderLabel,
    });
  };

  const handleSubmitCompanyForm = (e) => {
    if (e.selected_company) {
      let educationSelect = educationList.results.find(
        (item) => item.id == e.selected_company
      );
      let citySelect = constantsList.city.find(
        (item) => item.id == educationSelect.city
      );

      let genderSelect = constantsGenderList.find(
        (item) => item.id == educationSelect.gender
      );
      let selectArray = {
        id: e.selected_company,
        name: educationSelect.name,
        city: citySelect.shahr,
        gender: genderSelect.name,
      };
      dispatch({ type: cartType.SET_COMPANY_DETAILS, payload: selectArray });

      history.push(ROUTE_PAYMENT);
    } else {
      dispatch(showInfoAlert("لطفا یک سازمان را انتخاب کنید."));
      dispatch({ type: cartType.SET_COMPANY_DETAILS, payload: [] });
    }
  };

  const DeleteModal = () => {
    return (
      <StyledContainer className="p-0">
        <p className="pt-5">
          آیا می‌خواهید " {companyIdWillRemove.name} " را حذف کنید؟
        </p>
        <Row className="pt-3 pb-5 mx-auto d-flex justify-content-around">
          <Button onClick={() => dispatch(closeAlert())} className="col-5 p-0">
            خیر، حذف نمی کنم!
          </Button>
          <Button
            onClick={handleDeleteCompany}
            className="delete-button col-5 p-0"
          >
            بله، حذف می کنم!
          </Button>
        </Row>
      </StyledContainer>
    );
  };

  return (
    <>
      <LayoutPurchaseComponent
        classname="p-0 p-md-4"
        cardTitle="اشتراک گروهی"
        $height="auto"
        rowClassName="w-100"
      >
        <Wrapper className="p-0 d-flex flex-column justify-content-center align-items-center">
          <img
            src={grouplImg}
            alt="اشتراک گروهی"
            width="280"
            height="auto"
            className="mb-3"
          />
          <CartTableComponent theadData={theadData} className="px-md-1">
            {productList.map((productItem, index) => (
              <tr
                key={`tr-${index}`}
                className={
                  index === productList.length - 1 ? "tbody-last-tr" : ""
                }
              >
                <td>{productItem.gradeName}</td>
                <td>{productItem.number}</td>
                <td>{productItem.unitOfTimeName}</td>
                <td>
                  {productItem.totalPrice.toLocaleString()}
                  &nbsp;تومان
                  {productItem.discount === 0 ? (
                    <></>
                  ) : (
                    <>
                      <p className="discount-package">
                        تخفیف :{productItem.discount.toLocaleString()}
                        &nbsp;تومان
                      </p>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </CartTableComponent>
          <Form
            className="w-100"
            onSubmit={handleSubmit(handleSubmitCompanyForm)}
          >
            {educationList?.results.length !== 0 ? (
              <>
                <StyledCompanyCardsWrapper className="mx-auto px-2 px-md-0">
                  {educationList?.results.map((item) => (
                    <CompanyCardsComponent
                      data={item}
                      key={item.id}
                      selectedCompany={selectedCompany}
                      handleDeleteModal={handleDeleteModal}
                      handleEditModal={handleEditModal}
                      register={register("selected_company", {
                        onChange: (e) => setSelectedCompany(e.target.value),
                      })}
                    />
                  ))}

                  <StyledCreateNewCompany
                    to={handleCreateNewCompany}
                    className="w-100 d-flex flex-column justify-content-center align-items-center"
                  >
                    <p className="m-1 text-center">ایجاد سازمان جدید</p>
                    <Add size="32" color="var(--tertiary-color)" />
                  </StyledCreateNewCompany>
                </StyledCompanyCardsWrapper>
                <SecondaryButtonComponent
                  titleButton="ادامه و تایید خرید"
                  buttonType="submit"
                  isDisabledButton={!isValid}
                  wrapperButtonclassName="float-start col-12 col-md-3 my-5 my-md-3 mx-auto mx-md-0 px-3 px-md-1"
                />
              </>
            ) : (
              <Row className="mx-auto p-0 mb-4 d-flex justify-content-between align-items-end">
                <Col
                  xs={6}
                  sm={4}
                  md={3}
                  className="p-1 my-auto mx-auto mx-md-0"
                >
                  <StyledCreateNewCompany
                    to={handleCreateNewCompany}
                    className="mx-auto mx-md-0 d-flex flex-column justify-content-center align-items-center"
                  >
                    <p className="m-1 text-center">ایجاد سازمان جدید</p>
                    <Add size="32" color="var(--tertiary-color)" />
                  </StyledCreateNewCompany>
                </Col>
                <SecondaryButtonComponent
                  titleButton="ادامه و تایید خرید"
                  buttonType="submit"
                  isDisabledButton={true}
                  wrapperButtonclassName="mx-auto mx-md-0 col-12 col-md-3 p-2 pb-0 mt-5 mt-md-0"
                />
              </Row>
            )}
          </Form>
        </Wrapper>
      </LayoutPurchaseComponent>
    </>
  );
};

export default CartComponent;
